import * as S from './style'; 

function PrivacyMainSection() {
	return (
		<S.Provider>
			<S.Container>
				<S.Header>
					{`How do we look after your information?`}
				</S.Header>
				<S.Content>
					{`We limit the amount of personal data collected to what is required to fulfil our obligations to you. We restrict, secure and control all our information assets against unauthorised access, damage, loss or destruction: whether physical or electronic. We will keep your personal information while you are a client or as long as required to meet our legal regulatory obligations. We may keep it longer if we cannot delete it for legal, regulatory or technical reasons. With your assistance we try to maintain the accuracy of your personal data.`}
				</S.Content>
			</S.Container>
			<S.Container>
				<S.Header>
					{`How will we use the information about you?`}
				</S.Header>
				<S.Content>
					{`We will collect and use your information only where:`}
				</S.Content>
				<S.Ul>
					<S.Li>{`it’s necessary to provide the service or product your have requested i.e. to fulfil the terms of our engagement with you.`}</S.Li>
					<S.Li>{`to contact you to advise you of events, or general communication including blogs and industry insights based on legitimate interest. We will provide an option to unsubscribe to this if you choose.`}</S.Li>
					<S.Li>{`it’s necessary for us to meet our legal or regulatory obligations – to obey laws and regulations that apply to us.`}</S.Li>
				</S.Ul>
			</S.Container>
			<S.Container>
				<S.Header>
					{`Keeping you involved and informed`}
				</S.Header>
				<S.Content>
					{`We would like to send you information about our events or general communication including blogs and industry insights, which may be of interest to you. If you have consented to receive these communications, you may opt out any time by clicking the unsubscribe link at the bottom of any email. You have a right at any time to stop us from contacting you for these purposes or giving your information to other affiliated entities.`}
				</S.Content>
			</S.Container>
			<S.Container>
				<S.Header>
					{`Website visits `}
				</S.Header>
				<S.Content>
					{`We may collect information about your visits to our websites such as IP address, location, browser type, length of visit and number of page views. This information may be used to improve our websites’ usability and for marketing purposes. Personal data submitted on this website could be used for the purposes specified in this privacy policy or in any relevant parts of the website.`}
				</S.Content>
				<S.Content>
					{`Cookies are used on this website. A cookie is a text file sent by a web server to a web browser and stored in the browser. The file is then sent back to the server each time the browser requests a page from the server. This enables the web server to identify and track the web browser. `}
				</S.Content>
				<S.Content>
					{`We may send a cookie which may be stored by your browser on your computer’s hard drive. This information we obtain from the cookie could be used to improve the website’s usability and for marketing purposes. We may also use that information to recognise your computer when you visit our website, and to personalise our website for you. `}
				</S.Content>
				<S.Content>
					{`Browsers usually will allow you to refuse cookies, but this could have a negative impact on the usability of many websites. `}
				</S.Content>
				<S.Content>
					{`We will not provide any personal information to a third party unless you have given your permission. `}
				</S.Content>
				<S.Content>
					{`Our website contains links to other websites. This privacy policy only applies to this website so when you link to other websites you should read their own privacy policies. `}
				</S.Content>
			</S.Container>
			<S.Container>
				<S.Header>
					{`Access to your information and correction `}
				</S.Header>
				<S.Content>
					{`The accuracy of your information is important to us and we will update the information as appropriate. If you change your contact information, please notify us and we will update our records.`}
				</S.Content>
				<S.Content>
					{`You have a number of specific rights; these are summarised below:`}
				</S.Content>
				<S.Ul>
					<S.Li><S.Bold>{`Access `}</S.Bold>{`– You may ask for a copy of the information we hold about you and we will provide this within one month of receipt free of charge (we may charge a fee for subsequent or duplicate requests).`}</S.Li>
					<S.Li><S.Bold>{`Rectification `}</S.Bold>{`– You may ask us to correct any information that we hold that is inaccurate or incomplete.`}</S.Li>
					<S.Li><S.Bold>{`Erasure `}</S.Bold>{`– You may ask us to delete or cease processing data in certain situations. Please note that we will have regulatory obligations to retain information for certain time periods and we will retain such information as we believe is necessary to fulfil these obligations. `}</S.Li>
					<S.Li><S.Bold>{`Restrict processing `}</S.Bold>{`– You may ask us to cease processing information. This means that we will be able to retain it but no longer act upon it. In the event that you no longer need our services and terminate them we will automatically cease processing information. `}</S.Li>
					<S.Li><S.Bold>{`Portability `}</S.Bold>{`– You may have the right to have your data transferred to another service provider in an appropriate electronic format. Please note that we will have regulatory obligations to retain copies of the information as outlined previously. `}</S.Li>
					<S.Li><S.Bold>{`Objection `}</S.Bold>{`– You may have the right to object to us processing information or using it for marketing purposes.`}</S.Li>
				</S.Ul>
				<S.IContent>
					{`This is a brief summary of your rights and there may be restrictions on some of them. If you wish to explore any of these rights at any time, please contact us on the address below and we will be pleased to assist you. `}
				</S.IContent>
				<S.SHeader>
					{`Transferring your information outside of America`}
				</S.SHeader>
				<S.IContent>
					{`The majority of information is processed in the USA. However, as part of the services offered to you, some of your information may be transferred to countries outside of the USA. `}
				</S.IContent>
				<S.IContent>
					{`Where your information is being processed outside of the USA, we will take steps to ensure that appropriate security measures are taken with the aim of ensuring that your privacy rights continue to be protected as outlined in this policy. `}
				</S.IContent>
				<S.SHeader>
					{`Changes to our privacy notice`}
				</S.SHeader>
				<S.IContent>
					{`We keep our privacy notice under regular review, and we will place any updates on our website. `}
				</S.IContent>
			</S.Container>
			<S.Container>
				<S.Header>
					{`How to contact us`}
				</S.Header>
				<S.Content>
					{`Please contact us if you have any questions about our privacy policy or the information, we hold about you. `}
				</S.Content>
				<S.Content>
					{`Please let us know if you believe we are not holding your information correctly, if you are unhappy with how we have used your personal information or have any questions about our privacy notice or information we hold about you. Our Data Privacy Representative is Sarah Harvie who can be contacted at: `}
				</S.Content>
				<S.ContentItalic>
					{`Gain.Energy`}
				</S.ContentItalic>
				<S.ContentItalic>
					{`Denver, CO 80111, US`}
				</S.ContentItalic>
			</S.Container>
		</S.Provider>
	)
}

export default PrivacyMainSection;